import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { OTStateTable } from './value-row';
import { preventDefault, useCallbacks, usePartial } from 'shared/hooks/utils';
import { openOTDiagnosticsDialog } from 'console/redux/main-actions';
import { useAction } from 'shared/hooks/redux/hooks';
export const OpenThermCardLastBoilerState = memo(function OpenThermCardLastBoilerState(props) {
    const { device_id, number, ot } = props;
    const onClickOpenOTDiagnosticsDialog = useCallbacks([
        preventDefault,
        useAction(usePartial(openOTDiagnosticsDialog, device_id)),
    ]);
    return (_jsxs("div", { className: "ui-falarm-main-view-opentherm ui-card", children: [_jsxs("h1", { children: ["\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F \u0448\u0438\u043D\u0430 ", number != null && ` №${number}`] }), ot != null && _jsx(OTStateTable, { ot: ot }), _jsx("a", { href: "#", style: { fontSize: '80%' }, onClick: onClickOpenOTDiagnosticsDialog, children: "\u0434\u0438\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430" })] }));
});
export const OTCardsLastBoilerState = memo(function OTCardsLastBoilerState(props) {
    const { ot_zones_count = 0, otzones_last, id } = props;
    const result = [];
    for (let i = 0; i < ot_zones_count; i++) {
        const ot = otzones_last?.[i];
        if (ot == null) {
            continue;
        }
        const number = ot_zones_count > 1 ? i + 1 : undefined;
        result.push(_jsx(OpenThermCardLastBoilerState, { device_id: id, ot: ot, number: number }, `OpenThermCard-${i}`));
    }
    return _jsx(_Fragment, { children: result });
});
